import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="flex flex-col lg:flex-row min-h-[420px] md:min-h-[500px]">
      <div className="lg:w-1/2 relative overflow-hidden bg-background-200">
        <img
          src="https://readdy.ai/api/search-image?query=newsroom%20editorial%20team%20working%20late%20night%20with%20warm%20desk%20lamps%2C%20journalism%20atmosphere%2C%20professional%20media%20office%2C%20warm%20amber%20lighting%2C%20documentary%20style%20photography%2C%20clean%20composition%2C%20cinematic%20mood%2C%20high%20detail&width=900&height=600&seq=cta-left-01&orientation=landscape"
          alt="黑料在线编辑团队"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-8 md:p-10">
          <span className="text-xs text-white/60 font-medium uppercase tracking-wider block mb-2">Editorial Team</span>
          <h3 className="text-2xl md:text-4xl font-heading font-black text-white leading-tight">
            第一手<span className="block">真实爆料</span>权威发布
          </h3>
        </div>
      </div>

      <div className="lg:w-1/2 bg-background-50 flex items-center justify-center p-8 md:p-14">
        <div className="max-w-md text-center">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
            你有料要<span className="italic text-primary-600">爆？</span>
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-500 leading-relaxed">
            如果你掌握任何网红、明星的真实黑料，欢迎向我们投稿。
            我们承诺严格保护投稿人隐私，确保信息安全。
          </p>
          <Link
            to="/about#submit"
            className="inline-flex items-center gap-2 mt-8 px-8 py-3.5 bg-foreground-950 text-white rounded-full font-semibold text-sm hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            立即投稿爆料
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}